import React, { useState } from 'react';
import AdminLayout from './Layout/AdminLayout';
import ParkingStats from './ParkingStats';
import PaymentRecords from './PaymentRecords';
import PriceSettings from './PriceSettings';
import CurrentlyParked from './CurrentlyParked';
import RegisteredOwners from './RegisteredOwners';
import PlatformRevenue from './PlatformRevenue';
import Navbar from './Navbar';

const AdminDashboard = ({ user }) => {
  const [activeTab, setActiveTab] = useState('currently-parked');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <>
      <Navbar onMenuToggle={toggleSidebar} user={user} />
      <AdminLayout user={user} activeTab={activeTab} setActiveTab={setActiveTab} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}>
        {activeTab === 'currently-parked' && <CurrentlyParked />}
        {activeTab === 'stats' && <ParkingStats />}
        {activeTab === 'records' && <PaymentRecords />}
        {activeTab === 'platform-revenue' && <PlatformRevenue />}
        {activeTab === 'settings' && <PriceSettings />}
        {activeTab === 'owners' && <RegisteredOwners />}
      </AdminLayout>
    </>
  );
};

export default AdminDashboard;
